import { useContext } from 'react';

import { MAVLINK_MESSAGE_IDS as MESSAGE } from '@/define/messageId';
import { MessageContext } from '@/helpers/MessageProvider';
import useMavLinkAddress from '@/hooks/useMavLinkAddress';

const useCameraCommand = () => {
  const { publishCommand } = useContext(MessageContext);
  const { getAddress } = useMavLinkAddress();

  const gimbalMove = (robot, pitch, yaw) => {
    const address = getAddress(robot.id);
    publishCommand(robot, 'camera/gimbal/move', [[...address, pitch, yaw]]);
  };

  const gimbalReset = (robot) => {
    const address = getAddress(robot.id);
    publishCommand(robot, 'camera/gimbal/reset', [[...address], [...address]]);
  };

  const shoot = () => (robot) => {
    const address = getAddress(robot.id);
    const execute = () => publishCommand(robot, 'camera/shoot', [[...address]]);

    return {
      execute,
      topic: `${robot.id}/telemetry/${MESSAGE.COMMAND_ACK}`,
      isMatch: (data) => data.command === 203,
      isSuccess: (data) => data.result === 0,
    };
  };

  return {
    gimbalMove,
    gimbalReset,
    shoot,
  };
};

export default useCameraCommand;
